import { Box, Stack } from '@mui/material';
import { FC, ReactNode } from 'react';
import {
  HeaderWithCancelButtonProps,
  HeaderWithRegisterButton,
} from 'src/components/shien/atoms/Header/HeaderWithRegisterButton';

type ComponentProps = HeaderWithCancelButtonProps & {
  children: ReactNode;
};

export const HeaderWithRegisterButtonTemplate: FC<ComponentProps> = ({ children, ...rest }) => {
  return (
    <Stack sx={{ overflow: 'hidden', height: '100%' }}>
      <HeaderWithRegisterButton {...rest} />
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>{children}</Box>
    </Stack>
  );
};
